// libraries
import { useEffect, useState, useRef } from "react"

// providers
import { useAuthDataContext } from "@/_providers/Auth"
import { trans } from "@/_providers/Translation"

// helpers
import Api from "../../../../_helpers/Api"

// components
import GroupedBarChart from "../../../partials/GroupedBarChart"
import { getPaletteColor } from "../../../partials/chartTheme"
import { Button } from "@mui/material"
import CompactFilterLayout from "@/components/partials/CompactFilterLayout"
import DateRange from "@/components/partials/DateRange"
import filterImage from "@/assets/img/icons/filter.svg"

const INITIAL_FILTERS = {
  date_from: null,
  date_to: null,
}

export default function RemainingMessagesChart() {
  const { partner } = useAuthDataContext()

  const [filters, setFilters] = useState(INITIAL_FILTERS)
  const [data, setData] = useState(null)

  const compactFilterLayoutRef = useRef(null)
  const fetchDebounceRef = useRef(null)

  useEffect(() => {
    clearTimeout(fetchDebounceRef.current)
    fetchDebounceRef.current = setTimeout(() => {
      Api.get(
        `dashboard/remaining-messages?date_from=${filters.date_from || ""}&date_to=${filters.date_to || ""}`,
      )
        .then((res) => setData(res.data))
        .catch(() => setData(null))
    }, 300)
    return () => clearTimeout(fetchDebounceRef.current)
  }, [filters])

  function handleFilterChange(name, value) {
    setFilters((prev) => ({ ...prev, [name]: value }))
  }

  function getAppliedFiltersCount() {
    return filters.date_from || filters.date_to ? 1 : 0
  }

  const smsCount = data?.sms_count ?? partner()?.sms_count ?? 0
  const viberCount = data?.viber_count ?? partner()?.viber_count ?? 0
  const whatsappCount = data?.whatsapp_count ?? partner()?.whatsapp_count ?? 0

  const labels = ["SMS", "Viber", "WhatsApp"]

  const series = [
    {
      name: trans("labels.count"),
      perBarColors: [
        getPaletteColor(0),
        getPaletteColor(1),
        getPaletteColor(2),
      ],
      data: [smsCount, viberCount, whatsappCount],
    },
  ]

  return (
    <div className="messages-chart">
      <div className="head">
        <h3>{trans("random.remainingMessagesTitle")}</h3>
        <div className="right">
          <button
            className="button-add button-small"
            onClick={() =>
              window.open("https://eusystem.eu/sms-packets", "_blank")
            }
            style={{
              marginRight: 0,
            }}
          >
            {trans("buttons.getMessagesPackage")}
          </button>
          <Button
            onClick={(e) => {
              compactFilterLayoutRef.current.open(e)
            }}
          >
            <img src={filterImage} alt="Filter" />
            {getAppliedFiltersCount() ? (
              <i>{getAppliedFiltersCount()}</i>
            ) : (
              <></>
            )}
          </Button>
          <CompactFilterLayout
            ref={compactFilterLayoutRef}
            appliedFiltersCount={getAppliedFiltersCount()}
            onClearClick={() => setFilters(INITIAL_FILTERS)}
          >
            <div className="row">
              <div className="col">
                <DateRange
                  startDate={filters.date_from || ""}
                  endDate={filters.date_to || ""}
                  onStartDateChange={(date) =>
                    handleFilterChange("date_from", date)
                  }
                  onEndDateChange={(date) =>
                    handleFilterChange("date_to", date)
                  }
                />
              </div>
            </div>
          </CompactFilterLayout>
        </div>
      </div>
      <hr />
      <GroupedBarChart
        labels={labels}
        series={series}
        barWidth={80}
        roundedBottom
      />
    </div>
  )
}
